// Generated by CoffeeScript 2.4.1
(function() {
  var Operation, Promise, Record, Weaver, WeaverRelation, _, getMapper, util;

  Operation = require('./Operation');

  Weaver = require('./Weaver');

  Promise = require('bluebird');

  _ = require('lodash');

  util = require('./util');

  getMapper = function(isSynchronous) {
    return function(toIterate = [], ...rest) {
      var arrCopy;
      arrCopy = toIterate.slice(); // copy the array here, becuase function body might mutate `toIterate`
      if (isSynchronous) {
        return _.map(arrCopy, ...rest);
      } else {
        return Promise.mapSeries(arrCopy, ...rest);
      }
    };
  };

  Record = class Record {
    constructor(fromNode1, toNode1, relNode1) {
      this.fromNode = fromNode1;
      this.toNode = toNode1;
      this.relNode = relNode1;
    }

    equals(record) {
      return record instanceof WeaverRelation.Record && record.relNode.equals(this.relNode);
    }

  };

  WeaverRelation = (function() {
    class WeaverRelation {
      constructor(owner, key, backward = false) {
        this.owner = owner;
        this.key = key;
        this.backward = backward;
        this._pendingWrites = [];
        this._records = [];
      }

      pendingWrites() {
        if (this._cache != null) {
          return this._cache._pendingWrites;
        } else {
          return this._pendingWrites;
        }
      }

      _removeRecord(record) {
        var i, rec, results;
        i = 0;
        results = [];
        while (i < this._records.length) {
          rec = this._records[i];
          if (rec.equals(record)) {
            results.push(this._records.splice(i, 1));
          } else {
            results.push(i++);
          }
        }
        return results;
      }

      _getRecordsForToNode(toNode) {
        var j, len, record, ref, results;
        ref = this._records;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          if (record.toNode.equals(toNode)) {
            results.push(record);
          }
        }
        return results;
      }

      _getRecordsForFromNode(fromNode) {
        var j, len, record, ref, results;
        ref = this._records;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          if (record.fromNode.equals(fromNode)) {
            results.push(record);
          }
        }
        return results;
      }

      getRecords(node) {
        return [...this._getRecordsForToNode(node), ...this._getRecordsForFromNode(node)];
      }

      getRecordForRelNode(relNode) {
        var j, len, record, ref;
        ref = this._records;
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          if (record.relNode.equals(relNode)) {
            return record;
          }
        }
        return void 0;
      }

      async load() {
        var nodes, reloadedRelation;
        nodes = (await new Weaver.Query().restrict(this.owner).selectOut(this.key, '*').find());
        reloadedRelation = nodes[0].relation(this.key);
        this._records = reloadedRelation.allRecords();
        return reloadedRelation.all();
      }

      query() {
        return Promise.resolve([]);
      }

      to(node) {
        var ref, relNode;
        relNode = (ref = this._getRecordsForToNode(node)[0]) != null ? ref.relNode : void 0;
        if (relNode == null) {
          throw new Error(`No relation to a node with this id: ${node.id()}`);
        }
        return Weaver.RelationNode.load(relNode.id(), {
          graph: relNode.getGraph(),
          NodeClass: Weaver.RelationNode,
          includeRelations: true
        });
      }

      from(node) {
        var ref, relNode;
        relNode = (ref = this._getRecordsForFromNode(node)[0]) != null ? ref.relNode : void 0;
        if (relNode == null) {
          throw new Error(`No relation from a node with this id: ${node.id()}`);
        }
        return Weaver.RelationNode.load(relNode.id(), {
          graph: relNode.getGraph(),
          NodeClass: Weaver.RelationNode,
          includeRelations: true
        });
      }

      all() {
        var add, candidate, j, k, len, len1, list, node, record, ref;
        list = new Weaver.NodeList();
        ref = this._records;
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          add = true;
          candidate = this.backward ? record.fromNode : record.toNode;
          for (k = 0, len1 = list.length; k < len1; k++) {
            node = list[k];
            add && (add = !candidate.equals(node));
          }
          if (add) {
            list.push(candidate);
          }
        }
        return list;
      }

      allRecords() {
        return this._records;
      }

      first() {
        var ref, ref1;
        if (this.backward) {
          return (ref = this.allRecords()[0]) != null ? ref.fromNode : void 0;
        } else {
          return (ref1 = this.allRecords()[0]) != null ? ref1.toNode : void 0;
        }
      }

      addInGraph(node, graph, params = {}) {
        params.node = new Weaver.Node(void 0, graph);
        return this.add(node, params);
      }

      _createRelationNode(operation, params) {
        var result;
        result = Weaver.RelationNode.get(operation.id, {
          graph: operation.graph,
          NodeClass: Weaver.RelationNode
        });
        result.fromNode = params.owner;
        result.key = params.key;
        result.toNode = params.to;
        if (params.created != null) {
          result._createdAt = params.created;
        }
        if (params.creator != null) {
          result._createdBy = params.creator;
        }
        return result;
      }

      add(node, params = {}) {
        var operation, relationNode;
        params.owner = this.owner;
        params.key = this.key;
        params.to = node;
        if (params.addToPendingWrites == null) {
          params.addToPendingWrites = true;
        }
        operation = Operation.Node(this.owner).createRelation(params);
        if (params.addToPendingWrites) {
          this.pendingWrites().push(operation);
        }
        relationNode = void 0;
        if (this._cache != null) {
          this._cache.addRelation(this.owner.id(), this.owner.getGraph(), this.key, node.id(), node.getGraph(), operation.id, operation.graph);
          relationNode = this._cache.evokeNode(Weaver.Cache.signature(operation.id, operation.graph));
        } else {
          relationNode = this._createRelationNode(operation, params);
          this._records.push(new Record(this.owner, node, relationNode));
        }
        Weaver.publish("node.relation.add", {
          node: this.owner,
          key: this.key,
          target: node
        });
        return relationNode;
      }

      addIn(node, params = {}) {
        var operation, relationNode;
        params.owner = node;
        params.key = this.key;
        params.to = this.owner;
        if (params.addToPendingWrites == null) {
          params.addToPendingWrites = this._cache != null ? true : false;
        }
        operation = Operation.Node(this.owner).createRelation(params);
        relationNode = void 0;
        if (this._cache != null) {
          this._cache.addRelation(node.id(), node.getGraph(), this.key, this.owner.id(), this.owner.getGraph(), operation.id, operation.graph);
          relationNode = this._cache.evokeNode(Weaver.Cache.signature(operation.id, operation.graph));
          if (params.addToPendingWrites) {
            this.pendingWrites().push(operation);
          }
        } else {
          relationNode = this._createRelationNode(operation, params);
          this._records.push(new Record(node, this.owner, relationNode));
        }
        Weaver.publish("node.relation.add", {
          node: node,
          key: this.key,
          target: this.owner
        });
        return relationNode;
      }

      update(oldNode, newNode) {
        var j, len, newRecord, oldRecord, oldRecords, results;
        if (this.backward) {
          throw new Error("The update operation can not be called on a relationIn");
        }
        oldRecords = void 0;
        if (oldNode instanceof Record) {
          oldRecords = [oldNode];
        } else {
          oldRecords = this._getRecordsForToNode(oldNode);
        }
        if (oldNode != null) {
          newRecord = void 0;
          if (newNode instanceof Record) {
            newRecord = newNode;
          } else {
            newRecord = new Record(this.owner, newNode);
          }
          results = [];
          for (j = 0, len = oldRecords.length; j < len; j++) {
            oldRecord = oldRecords[j];
            results.push(this._update(oldRecord, newRecord));
          }
          return results;
        } else {
          return this.add(newNode);
        }
      }

      async onlyTo(targets) {
        var i, j, k, l, len, len1, len2, record, records, target, toAdd, toDelete, used;
        if (!_.isArray(targets)) {
          targets = [targets];
        }
        records = this.allRecords();
        used = [];
        toDelete = [];
        toAdd = [];
        for (j = 0, len = records.length; j < len; j++) {
          record = records[j];
          for (i = k = 0, len1 = targets.length; k < len1; i = ++k) {
            target = targets[i];
            if (!used.find(function(index) {
              return index === i;
            })) {
              if (record.toNode.equals(target)) {
                used.push(i);
                break;
              }
            }
          }
          if (!targets.find(function(t) {
            return record.toNode.equals(t);
          })) {
            toDelete.push(record);
          }
        }
        for (i = l = 0, len2 = targets.length; l < len2; i = ++l) {
          target = targets[i];
          if (!(used.find(function(index) {
            return index === i;
          }) > -1)) {
            toAdd.push(target);
            used.push(i);
          }
        }
        await Promise.mapSeries(toDelete, (record) => {
          if (toAdd.length === 0) {
            return this.remove(record);
          } else {
            return this.update(record, toAdd.shift());
          }
        });
        return toAdd.map((node) => {
          return this.add(node);
        });
      }

      _update(oldRecord, newRecord) {
        var graph, operation, params, record;
        record = new Record(newRecord.fromNode, newRecord.toNode);
        this._removeRecord(oldRecord);
        this._records.push(record);
        graph = oldRecord.relNode.getGraph() || this.owner.getGraph();
        params = {};
        params.node = new Weaver.Node(void 0, graph);
        params.owner = this.owner;
        params.key = this.key;
        params.to = record.toNode;
        params.replaces = oldRecord.relNode;
        if (params.addToPendingWrites == null) {
          params.addToPendingWrites = true;
        }
        operation = Operation.Node(this.owner).createRelation(params);
        record.relNode = this._createRelationNode(operation, params);
        this.pendingWrites().push(operation);
        Weaver.publish("node.relation.update", {
          node: this.owner,
          key: this.key,
          oldTarget: oldRecord.toNode,
          target: newRecord.toNode
        });
        return record.relNode;
      }

      _clear(project, sync = false) {
        if (this.backward) {
          throw new Error("The clear operation can not be called on a relationIn");
        }
        return getMapper(sync)(this._records, (record) => {
          return this._remove(record, project, sync);
        });
      }

      clear(project) {
        return this._clear(project);
      }

      clearSync(project) {
        return this._clear(project, true);
      }

      remove(node, project) {
        if (this.backward) {
          throw new Error("The remove operation can not be called on a relationIn");
        }
        if (node instanceof Record) {
          return this._remove(node, project);
        } else {
          return getMapper()(this._getRecordsForToNode(node), (record) => {
            return this._remove(record, project);
          });
        }
      }

      removeSync(node, project) {
        if (this.backward) {
          throw new Error("The remove operation can not be called on a relationIn");
        }
        if (node instanceof Record) {
          return this._remove(node, project, true);
        } else {
          return getMapper(true)(this._getRecordsForToNode(node), (record) => {
            return this._remove(record, project, true);
          });
        }
      }

      _remove(record, project, sync = false) {
        // remove locally
        this._removeRecord(record);
        Weaver.publish("node.relation.remove", {
          node: this.owner,
          key: this.key,
          target: record.toNode
        });
        if (!record.relNode._stored) {
          return util.getResolver(sync)(void 0);
        } else {
          this.pendingWrites().push(Operation.Node().removeRelation({
            node: record.relNode
          }));
          if (!sync) {
            return this.owner.save({
              project: project
            });
          }
        }
      }

    };

    WeaverRelation.Record = Record;

    return WeaverRelation;

  }).call(this);

  // Export
  module.exports = WeaverRelation;

}).call(this);
